import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Check from "@material-ui/icons/Check";

import { clearConsultAnswersJSON } from "~/visits/utils/visitCookies";

import PropTypes from "prop-types";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import withStyles from "@material-ui/core/styles/withStyles";
import { useTheme } from "@mui/material/styles";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import Button from "../../material-dashboard/components/CustomButtons/Button.jsx";

import GridContainer from "../../material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "../../material-dashboard/components/Grid/GridItem.jsx";
import Card from "../../material-dashboard/components/Card/Card.jsx";
import CardBody from "../../material-dashboard/components/Card/CardBody.jsx";

import consultationStyles from "../styles/consultationStyles.js";
import { kickBlue } from "~/shared/styles/baseStyles.js";

import { bugsnagClient } from "~/shared/utils/errorHandling.js";

const buttonStyles = {
  fontWeight: "bold",
  backgroundColor: kickBlue,
  textTransform: "none",
  fontSize: "14px",
  marginBottom: "20px",
};
const outlinedButtonStyles = {
  ...buttonStyles,
  border: "1px solid",
  backgroundColor: "white",
  color: kickBlue,
};

const SubscriptionFollowUpVisitComplete = (props) => {
  const { classes } = props;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const checkoutSessionID = queryParams.get('checkoutSessionID');
  clearConsultAnswersJSON(checkoutSessionID);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div
      className={`${classes.containerWithSpacing} payment-section`}
      style={{ minHeight: "60vh", justifyContent: "center" }}
    >
      <GridContainer justifyContent="center">
        <GridItem
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className={classes.paymentCompleteCongrats}>
            <div
              style={{
                borderRadius: "100%",
                backgroundColor: kickBlue,
                height: "60px",
                width: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "24px",
              }}
            >
              <Check style={{ color: "#fff", fontSize: "42px" }} />
            </div>
            <p
              className={classes.subtitle}
              style={{ textAlign: "center", marginBottom: "16px" }}
            >
              Follow-Up complete
            </p>
          </div>

          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginTop: "16px",
              lineHeight: "26px",
            }}
          >
            Your follow-up visits has been received. We'll email you as soon as
            your provider has reviewed your visit.
          </p>
          <div
            style={{
              fontFamily: "BasisGrotesquePro-Regular",
              fontSize: "18px",
              lineHeight: "26px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <br />
            <Button
              href="https://www.gokick.com/treatment"
              style={{
                ...outlinedButtonStyles,
                width: isMobile ? "100%" : "320px",
              }}
            >
              Treatment Plans
            </Button>
            <Button
              href="https://www.gokick.com/guides/"
              style={{
                ...outlinedButtonStyles,
                width: isMobile ? "100%" : "320px",
              }}
            >
              Kick Guides
            </Button>
            <Button
              href="/me/messages/care/"
              style={{
                ...outlinedButtonStyles,
                width: isMobile ? "100%" : "320px",
              }}
            >
              Secure Message Your Care Team
            </Button>
            <Button
              href="/me/portal/"
              style={{
                ...buttonStyles,
                width: isMobile ? "100%" : "320px",
              }}
            >
              Back to My Account
              <NavigateNextIcon />
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(
  SubscriptionFollowUpVisitComplete
);
